/**
 * 库存操作-报损管理
 */

//报损类型(1-发货亏损，2-残次品报损，3-收货亏损，4-风黄污损报损)
export enum LossTypeEnum {
    /**
     * 发货亏损
     */
    SEND = 1,
    /**
     * 残次品报损
     */
    RESIDUAL = 2,
    /**
     * 收货亏损
     */
    RECEIVE = 3,
    /**
     * 风黄污损报损
     */
    WIND = 4
}
export enum LossTypeEnumName {
    /**
     * 发货亏损
     */
    SEND = '发货亏损',
    /**
     * 残次品报损
     */
    RESIDUAL = '残次品报损',
    /**
     * 收货亏损
     */
    RECEIVE = '收货亏损',
    /**
     * 风黄污损报损
     */
    WIND = '风黄污损报损'
}

// 审批状态(1-待提交，2-审核中，3-审核通过，4-审核未通过)
export enum ExamineStatusEnum {
    /**
     * 待提交
     */
    WAIT = 1,
    /**
     * 审核中
     */
    AUDITING = 2,
    /**
     * 审核通过
     */
    PASS = 3,
    /**
     * 审核未通过
     */
    NOT_PASS = 4
}
export enum ExamineStatusEnumName {
    /**
     * 待提交
     */
    WAIT = '待提交',
    /**
     * 审核中
     */
    AUDITING = '审核中',
    /**
     * 审核通过
     */
    PASS = '审核通过',
    /**
     * 审核未通过
     */
    NOT_PASS = '审核未通过'
}
